import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import {
  getCompanyLabels,
  getCountryLabels,
} from '@Store/selectors/dictionarySelector';
import { DateRange, Input, MultiSelect, Select } from '@Components/Filters';
import { SponsorTypeCodes } from '@Enum/api/SponsorTypeCodes.enum';

import { FilterForm } from './types';
import {
  getSponsorOptions,
  getStatusLabels,
} from '../store/selectors/overseasMissionSelector';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const statusLabels = useAppSelector(getStatusLabels);
  const sponsorsOptions = useAppSelector(getSponsorOptions);
  const countryLabels = useAppSelector(getCountryLabels);
  const companyLabels = useAppSelector(getCompanyLabels);

  const items: CollapseProps['items'] = [
    {
      id: 'PLACE OF TRAVEL',
      label: 'Place of Travel',
      children: <Input<FilterForm> formik={formik} formikKey="placeOfTravel" />,
    },
    {
      id: 'DATE RANGE',
      label: 'Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="travelDate"
          toKey="returnDate"
        />
      ),
    },
    {
      id: 'TOTAL NO OF DAYS',
      label: 'Total no. of days',
      children: <Input<FilterForm> formik={formik} formikKey="totDays" />,
    },
    {
      id: 'PURPOSE OF TRAVEL',
      label: 'Purpose of Travel',
      children: (
        <Input<FilterForm> formik={formik} formikKey="purposeOfTravel" />
      ),
    },
    {
      id: 'APPROVED TRAVEL AMOUNT',
      label: 'Approved Travel Amount',
      children: (
        <Input<FilterForm> formik={formik} formikKey="approvedTravelAmount" />
      ),
    },
    {
      id: 'COUNTRY',
      label: 'Country',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="country"
          options={countryLabels}
          showSearch
        />
      ),
    },
    {
      id: 'SPONSORED BY',
      label: 'Sponsored by',
      children: (
        <Select<FilterForm>
          formik={formik}
          formikKey="sponsoredBy"
          options={sponsorsOptions}
        />
      ),
    },
  ];

  if (formik.values.sponsoredBy === String(SponsorTypeCodes.COMPANY)) {
    items.push({
      id: 'COMPANY NAME',
      label: 'Company Name',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="companyName"
          options={companyLabels}
          showSearch
        />
      ),
    });
  }

  if (formik.values.sponsoredBy === String(SponsorTypeCodes.SUB_CONTRACTOR)) {
    items.push({
      id: 'SUBCONTRACTOR NAME',
      label: 'Sub-contractor Name',
      children: (
        <Input<FilterForm> formik={formik} formikKey="subContractorName" />
      ),
    });
  }

  if (formik.values.sponsoredBy === String(SponsorTypeCodes.SUPPLIER)) {
    items.push({
      id: 'SUPPLIER NAME',
      label: 'Supplier Name',
      children: <Input<FilterForm> formik={formik} formikKey="supplierName" />,
    });
  }

  items.push({
    id: 'STATUS',
    label: 'Status',
    children: (
      <MultiSelect<FilterForm>
        formik={formik}
        formikKey="statuses"
        options={statusLabels}
        showSearch
      />
    ),
  });

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
